let i = 0;

const generateId = () => {
  i += 1;
  return `gen-${i}`;
};

export default generateId;
